import { render, staticRenderFns } from "./AddPayment.template.vue?vue&type=template&id=5c564b32&scoped=true&"
var script = {}
import style0 from "./AddPayment.template.vue?vue&type=style&index=0&id=5c564b32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c564b32",
  null
  
)

export default component.exports